import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

export default function PrimaryButton({
    text,
    onClick,
    fontSizeOverride,
    loading = false,
    disabled = false,
    disabledTooltip = '',
}) {
    const handleWrapperClick = (e) => {
        if (!disabled || disabledTooltip === '') {
            return;
        }

        e.stopPropagation();
        window.alert(disabledTooltip);
    };

    return (
        <Box
            onClick={handleWrapperClick}
            sx={{
                display: 'block', // takes full width
                width: '100%', // wrapper won't constrain the button
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Button
                onClick={onClick}
                variant="contained"
                disabled={disabled}
                sx={{
                    backgroundColor: 'rgb(39,90,71)',
                    color: '#FFFFFF',
                    borderRadius: '999px',
                    paddingX: 4,
                    paddingY: 2,
                    marginBottom: 3.5,
                    fontSize: fontSizeOverride || 20,
                    textTransform: 'none',
                    width: '80%',
                    maxWidth: '400px',
                    '&:hover': {
                        backgroundColor: '#1A3F2D',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: 'rgba(39,90,71,0.4)', // custom disabled background
                        color: 'rgba(255,255,255,0.6)', // custom disabled text
                    },
                }}
            >
                {/* keep text present to preserve sizing */}
                <span style={{ visibility: loading ? 'hidden' : 'visible' }}>{text}</span>

                {loading && (
                    <CircularProgress
                        size="1.5em"
                        sx={{
                            color: 'green',
                            position: 'absolute',
                        }}
                    />
                )}
            </Button>
        </Box>
    );
}
